import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FlexDiv, GenericSpan } from 'commonStyles';
import { Header, FilterContent } from './BottomFilterStyles';
import BottomElement from './BottomElement';
import Button from 'common/Button/Button';
import { updateFilterObj } from 'reduxStore/actions/miceActionDispatcher';
import BottomRadioField from './BottomRadioField';

import { destinationSearchFilters } from '../../../../config';
import { formatTrackingMiceValue, trackMiceClick } from 'UtilityComponents/miceUtils';

const FilterBottomSheet = ({ searchResults, toggleFilter, isMobile }) => {
	const dispatch = useDispatch();

	const searchFilterData = useSelector((state) => state.mice.searchFilterData);

	const handleSelection = (key, value) => {
		dispatch(updateFilterObj({ [key]: value }));
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		const params = {};
		destinationSearchFilters.forEach((flt) => {
			if (flt.value) {
				params[flt.key] = flt.value.urlDataKey;
			}
		});
		const trackVal = formatTrackingMiceValue({ ...params, ...searchFilterData });
		trackMiceClick(trackVal);

		searchResults(params);
		toggleFilter();
	};

	return (
		<FlexDiv directionInMobile='column'>
			<Header>
				<p>Explore <GenericSpan color='#000' fsize='22px' f_weight='900'>Venues by</GenericSpan></p>
			</Header>
			<FilterContent directionInMobile='column'>
				{destinationSearchFilters && destinationSearchFilters.map((field) => {
					const { key } = field;
					return key === 'eventType' ?
						<BottomRadioField key={key} value={searchFilterData[key]} field={field} handleSelection={handleSelection} isMobile={isMobile} /> :
						<BottomElement key={key} value={searchFilterData[key]} field={field} handleSelection={handleSelection} />;
				})}
			</FilterContent>
			<Button
				btnTxt='EXPLORE'
				btnType='Flat'
				btnName='Primary'
				btnShadow
				handleClick={handleSubmit}
			/>
		</FlexDiv>
	);
};

export default FilterBottomSheet;
